import React, {Component} from 'react';
import axios from 'axios'
import {locale} from '../locale/AppLocale';
import Loader from '../Components/Loader'
import ReactPaginate from 'react-paginate';
import ShooqModal from '../Components/ShooqModal';
import Config from '../Helpers/Config';
import {NotificationManager} from '../Helpers/NotificationManager';;
import {connect} from 'react-redux'
import * as authActions from '../actions/authActions'

class Orders extends Component {

    constructor(props) {
        super(props);
        this.state = {
            businessSlug: props.match.params.businessSlug,
            status: (  props.match.params.status === 'all' ? 'all' : (parseInt(props.match.params.status, 10) || 2)),
            is_loading: false,
            fetched: false,
            fetchingOrderModalItems: false,
            orderModal: false,
            openModal: false,
            tabStatuses: [],
            orders: [],
            changingStatusQueue: [],
            pagination: {
                before: 0,
                current: 0,
                next: 0,
                last: 0,
                first: 0,
                total_pages: 0,
                total_items: 0,
            },
        };

        this.loadMore = this.loadMore.bind(this);
        this.changeStatus = this.changeStatus.bind(this);
        this.addOrderToQueue = this.addOrderToQueue.bind(this);
        this.removeOrderFromQueue = this.removeOrderFromQueue.bind(this);
        this.removeOrder = this.removeOrder.bind(this);
        this.updateOrder = this.updateOrder.bind(this);
        this.showModal = this.showModal.bind(this);
        this.renderModalContent = this.renderModalContent.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.fetchByStatus = this.fetchByStatus.bind(this);
        this.renderOrderItems = this.renderOrderItems.bind(this);
        this.fetchOrderItems = this.fetchOrderItems.bind(this);

    }

    componentDidMount() {
        this.fetchOrders(1, this.props.match.params.status);
    }

    showModal(orderId) {
        this.setState({openModal: true, orderModal: false, fetchingOrderModalItems: true}, () => {
            this.fetchOrderItems(orderId);
        });
    }

    closeModal(...proxy) {
        this.setState({openModal: false, orderModal: false});
    }

    renderModalContent() {
        if (!this.state.openModal) {
            return;
        }

        return (
            this.state.fetchingOrderModalItems ? <Loader completed={!this.state.fetchingOrderModalItems}/> :
                <div>
                    <table className="table ">
                        <thead>
                        <tr>
                            <th className="cell--gray no-hover"><span className="mr-10">{locale.get('total_products')}:</span> <span className="badge badge--small">{this.state.orderModal.order_details.total_items}</span></th>
                            <th className="cell--gray no-hover">{locale.get('buyer_name')}</th>
                            <th className="cell--gray no-hover">{locale.get('address')}</th>
                            <th className="cell--gray no-hover">{locale.get('mobile')}</th>
                            <th className="cell--gray no-hover">{locale.get('payment_method')}</th>
                            <th  className="cell--gray no-hover" width="110px">{locale.get('order_date')}</th>
                            <th className="cell--gray no-hover">{locale.get('payment_method_fees')}</th>
                            <th className="cell--gray no-hover">{locale.get('shipping_fees')}</th>
                            <th className="cell--gray no-hover">{locale.get('sub_total')}</th>
                            <th className="cell--gray no-hover">{locale.get('total')}</th>
                            <th className="cell--gray no-hover">{locale.get('shippping_policy_for_all')}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>{locale.get('total_ready_orders',{completed: this.state.orderModal.order_details.completed_items, total_orders: this.state.orderModal.order_details.items_to_process})}</td>
                            <td>{this.state.orderModal.order_details.buyer.full_name}</td>
                            <td>{this.state.orderModal.order_details.buyer.address}</td>
                            <td dir="ltr">{this.state.orderModal.order_details.buyer.mobile}</td>
                            <td>{
                                this.state.orderModal.order_details.payment.replace(/\(.*?\)\s?/g, '')

                            }</td>
                            <td title={this.state.orderModal.order_details.date}>{this.state.orderModal.order_details.short_date}</td>
                            <td>{this.state.orderModal.order_details.fees}</td>
                            <td>{this.state.orderModal.order_details.shipping_fees}</td>
                            <td>{this.state.orderModal.order_details.sub_total}</td>
                            <td>{this.state.orderModal.order_details.total}</td>
                            <td>
                                {this.state.orderModal.order_details.grouped_order && this.state.orderModal.order_details.shipping_policy_url !== false ?
                                    <a href={this.state.orderModal.order_details.shipping_policy_url} target="_blank">
                                        {locale.get('shippping_policy_for_all')}
                                    </a>
                                    : '---'}
                            </td>

                        </tr>
                        </tbody>
                    </table>
                    <br/>

                    {
                        <table className="table ">
                            <thead>
                            <tr>
                                <th className="cell--gray no-hover" >#</th>
                                <th  className="cell--gray no-hover" colSpan={2} width="40%">{locale.get('product_name')}</th>
                                <th className="cell--gray no-hover" >{locale.get('quantity')}</th>
                                <th className="cell--gray no-hover" >{locale.get('price')}</th>
                                <th className="cell--gray no-hover" >{locale.get('payment_method_fees')}</th>
                                <th className="cell--gray no-hover" >{locale.get('shipping_fees')}</th>
                                <th className="cell--gray no-hover" >{locale.get('sub_total')}</th>
                                <th className="cell--gray no-hover" >{locale.get('order_total')}</th>
                                <th className="cell--gray no-hover" >{locale.get('status')}</th>
                                <th className="cell--gray no-hover" >{locale.get('shippping_policy')}</th>
                                <th className="cell--gray no-hover" >{locale.get('shipping_method')}</th>
                            </tr>
                            </thead>
                            {
                                this.state.orderModal !== false ? (
                                    <tbody key={`body-orderModal`}>
                                    {
                                        this.state.orderModal.order_items.map((order, index) => {
                                            return this.renderOrderItems(order, index, 'order-modal')
                                        })
                                    }
                                    </tbody>

                                ) : (<tr>
                                    <td colSpan="12">
                                        <div className="text-center">{locale.get('no_orders_found')}</div>
                                    </td>
                                </tr>)
                            }

                        </table>
                    }

                </div>
        );
    }

    fetchOrders(page = 1, statusId = 2) {


        if (!this.props.auth.can_request) {
            return false;
        }

        axios.get(`${Config.api()}/orders/list/${this.props.auth.business.id}?status=${statusId}&page=${page}`, {
            withCredentials: true
        })
            .then((response) => {
                if (response.status === 200) {
                    this.setState({
                        is_loading: false,
                        fetched: true,
                        tabStatuses: response.data.tabStatuses,
                        orders: response.data.orders,
                        pagination: response.data.pagination,
                        changingStatusQueue: [],
                    });
                }
            }).catch((error) => {
            if (error.response.status === 401) {
                this.props.requiresReLogin();
            } else {
                NotificationManager.error(error.message);
            }
            this.setState({fetched: true});
        });
    }

    loadMore(props) {
        let page = (props.selected + 1) || 1;
        if (this.state.is_loading || page > this.state.pagination.total_pages) {
            return;
        }
        this.setState({is_loading: true});
        this.fetchOrders((props.selected + 1), this.state.status);
    }

    fetchOrderItems(orderId) {
        if (!this.props.auth.can_request) {
            return false;
        }

        axios.get(`${Config.api()}orders/find-items/${this.props.auth.business.id}/${orderId}`, {
            withCredentials: true
        })
            .then((response) => {
                if (response.status === 200) {
                    console.log('response.data', response.data)
                    this.setState({
                        fetchingOrderModalItems: false,
                        orderModal: response.data
                        // orders: response.data.orders,
                    });
                }
            }).catch((error) => {
            if (error.response.status === 401) {
                this.props.requiresReLogin();
            } else {
                NotificationManager.error(error.message);
            }
            this.setState({fetched: true});
        });

    }

    fetchByStatus(e, statusId) {
        e.preventDefault();
        this.setState({status: statusId, fetched: false, is_loading: true, orders: []});
        this.props.history.push(`/${this.props.match.params.businessSlug}/orders/${statusId}`);
        this.fetchOrders(1, statusId);
    }

    renderTable() {
        return (
            <div>
                <table className="table no-border-top">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>{locale.get('product_name')}</th>
                        <th>{locale.get('order_date')}</th>
                        <th>{locale.get('quantity')}</th>
                        <th>{locale.get('price')}</th>
                        <th>{locale.get('payment_method_fees')}</th>
                        <th>{locale.get('shipping_fees')}</th>
                        <th>{locale.get('sub_total')}</th>
                        <th>{locale.get('order_total')}</th>
                        <th>{locale.get('status')}</th>
                        <th>{locale.get('shippping_policy')}</th>
                        <th>{locale.get('shipping_method')}</th>
                    </tr>

                    </thead>
                    {
                        this.state.orders.length > 0 ? (
                            this.state.orders.map((orderGroup, ordersListIndex) => {
                                return (
                                    <tbody key={`body-${ordersListIndex}`}>
                                    <tr>
                                        <th className="cell--gray no-hover">
                                            <div className="badge badge--small">{locale.get('show_orders_count',{currentTotal: orderGroup['order_items'].length, total_orders: orderGroup.order_details.total_items })}</div>
                                        </th>
                                        <th className="cell--gray no-hover">
                                            {orderGroup.order_details.buyer.full_name}
                                        </th>
                                        <th className="cell--gray no-hover" colSpan={1} title={orderGroup.order_details.date}>
                                            {orderGroup.order_details.short_date}
                                        </th>
                                        <th className="cell--gray no-hover">

                                        </th>
                                        <th className="cell--gray no-hover" >

                                        </th>
                                        <th className="cell--gray no-hover" title={orderGroup.order_details.fees}>
                                            {orderGroup.order_details.fees}
                                        </th>
                                        <th className="cell--gray no-hover" title={orderGroup.order_details.shipping_fees}>
                                            {orderGroup.order_details.shipping_fees}
                                        </th>
                                        <th className="cell--gray no-hover" title={orderGroup.order_details.sub_total}>
                                            {orderGroup.order_details.sub_total}
                                        </th>
                                        <th className="cell--gray no-hover" title={orderGroup.order_details.total}>
                                            {orderGroup.order_details.total}
                                        </th>
                                        <th className="cell--gray no-hover">
                                            <button
                                                onClick={(e) => {
                                                    this.showModal(orderGroup.order_details.id)
                                                }}
                                                className="btn btn--block btn-3 btn--small">{locale.get('order_details')} ({locale.get('total_ready_orders',{completed: orderGroup.order_details.completed_items, total_orders: orderGroup.order_details.items_to_process})})</button>
                                        </th>
                                        <th className="cell--gray no-hover">
                                            {orderGroup.order_details.grouped_order && orderGroup.order_details.shipping_policy_url !== false ?
                                                <a href={orderGroup.order_details.shipping_policy_url} target="_blank">
                                                    {locale.get('shippping_policy_for_all')}
                                                </a>
                                                : '---'}

                                        </th>
                                        <th className="cell--gray no-hover">
                                            <p className={'badge badge--6'}>{orderGroup.order_details.delivery_option.label}</p>
                                        </th>
                                    </tr>
                                    {
                                        orderGroup['order_items'].map((order, index) => {
                                            return this.renderOrderItems(order, index, ordersListIndex)
                                        })
                                    }
                                    </tbody>
                                )
                            })

                        ) : (
                            <tbody>
                                <tr>
                                    <td colSpan="12">
                                        <div className="text-center">{locale.get('no_orders_found')}</div>
                                    </td>
                                </tr>
                            </tbody>
                        )
                    }

                </table>
            </div>
        )
    }

    renderOrderItems(order, index, ordersListIndex) {
        return (
            <tr key={`items-${ordersListIndex}-${index}`}>
                <td className=" has-flying-badge ">
                    <div className="badge badge--small badge--6 ">{index + 1}</div>
                    <img className="pull-default" width="70px" src={order.image} alt={order.product_name}/>
                </td>
                <td colSpan={2} onClick={(e) => {
                    e.preventDefault();
                    if(!this.state.openModal){
                        this.showModal(order.order_id)
                    }
                }} className={` ${this.state.openModal ? '' : ' is-pointer '}${order.canceled === true ? `line-through` : ``}`}>
                    <div className="pull-default badge badge--6 badge--small ml-10"><span
                        className="pull-default">#</span><span>{order.id}</span>
                    </div>
                    <div>
                        {order.product_name}
                    </div>
                    { order.customer_notes && order.customer_notes.length ? (
                        <div className="mt-10">
                            <div className="badge badge--6 badge--small text-right">
                                <span className="ml-10">{locale.get('buyer_notes')}:</span>
                                <span>{order.customer_notes || `---`}</span>
                            </div>
                        </div>
                    ) : ('') }
                </td>
                <td>{order.quantity}</td>
                <td>{order.price}</td>
                <td>{order.fees}</td>
                <td>{order.shipping_fees}</td>
                <td>{order.sub_total}</td>
                <td>{order.total}</td>
                <td title={order.status_text}>
                    {this.getOrderStatusButton(order)}
                </td>

                <td>
                    {order.shipping_policy_url ?
                        <a href={order.shipping_policy_url} target="_blank">
                            {locale.get('shippping_policy')}
                        </a>
                        : '---'}
                </td>
                <td>
                    <div>
                        <p className={'badge badge--6'}>{order.delivery_option.label}</p>
                    </div>
                    <div className={`mt-10`}>
                        { order.shipping_by_seller === true ? locale.get('order_shipping_by_seller') : locale.get('order_shipping_by_shooq') }

                    </div>

                </td>

            </tr>
        )
    }


    getOrderStatusButton(order) {
        if (order.can_change_status === true) {
            return (
                <button className="btn-2 btn--small btn--block" type="button" onClick={() => {
                    this.changeStatus(order)
                }}>
                    {order.business_status_text}
                    <Loader completed={!this.isOrderInQueue(order)}/>
                </button>
            );
        }

        return order.business_status_text;
    }

    getCurrentStatus() {
        if (this.state.status === 'all') {
            return this.state.status;
        }
        return parseInt(this.state.status, 0);
    }

    render() {
        return (
            <div>
                <div className="panel-1">
                    <div className="panel-1--head no-border-btm">
                        {locale.get('manage_orders')}
                    </div>
                    {this.state.tabStatuses.length > 0 ? (
                        <div className="panel-1--tabs">
                            <ul>
                                {this.state.tabStatuses.map((status, index) => {
                                    return (
                                        <li key={index}
                                            className={ this.getCurrentStatus() === status.id ? 'active' : '' }>
                                            <a href={'#' + status.id} onClick={(e) => {
                                                this.fetchByStatus(e, status.id);
                                            }}>{status.title}</a>
                                        </li>
                                    )
                                })}
                            </ul>
                            <div className="clearfix"/>
                        </div>
                    ) : ('')}
                    <div className="clearfix"/>
                    <Loader completed={this.state.fetched && this.state.is_loading === false}>
                        {this.renderTable()}

                        {this.state.openModal ? (
                            <ShooqModal showModal={this.state.openModal} onRequestClose={this.closeModal}
                                         modalTitle={locale.get('order_number') + (this.state.orderModal ? this.state.orderModal.order_details.id : '')}
                                         className={`shooq-modal--large`}
                                         modalSubTitle={this.state.orderModal.order_details ?  this.state.orderModal.order_details.buyer.full_name : ''}
                            >

                                {this.renderModalContent()}

                            </ShooqModal>) : ('')}

                    </Loader>

                    {
                        (this.state.fetched && this.state.is_loading === false && this.state.pagination.total_pages > 1) ? (
                            <div className="panel-1--body">
                                <ReactPaginate previousLabel={locale.get('previous')}
                                               nextLabel={locale.get('next')}
                                               breakLabel={<span>...</span>}
                                               breakClassName={"break-me"}
                                               pageCount={this.state.pagination.total_pages}
                                               initialPage={this.state.pagination.current - 1}
                                               disableInitialCallback={true}
                                               marginPagesDisplayed={2}
                                               pageRangeDisplayed={5}
                                               onPageChange={this.loadMore}
                                               containerClassName={"pagination"}
                                               subContainerClassName={"pages pagination"}
                                               activeClassName={"active"}/>
                            </div>
                        ) : ('')
                    }
                </div>
            </div>
        );
    }

    isOrderInQueue(order) {
        return this.state.changingStatusQueue.indexOf(order) > -1;
    }

    addOrderToQueue(order) {
        if (this.isOrderInQueue(order)) {
            return;
        }
        let changingStatusQueue = this.state.changingStatusQueue;
        changingStatusQueue.push(order);
        this.setState({changingStatusQueue: changingStatusQueue});
        NotificationManager.info(locale.get('changing_order_status'), locale.get('order_number') + order.id);
    }

    removeOrderFromQueue(order) {
        if (this.isOrderInQueue(order) === false) {
            return;
        }

        const changingStatusQueue = this.state.changingStatusQueue;
        if (changingStatusQueue.indexOf(order) > -1) {
            changingStatusQueue.splice(changingStatusQueue.indexOf(order), 1);
            this.setState({changingStatusQueue: changingStatusQueue})
        }
    }

    removeOrder(order) {
        let orders = this.state.orders;
        for (let i=0;i<orders.length;i++){
            let orderItems = orders[i]['order_items'];
            if (orderItems.indexOf(order) > -1) {
                orderItems.splice(orderItems.indexOf(order), 1);
                if(orderItems.length === 0){
                    orders.splice(i, 1);
                }else{
                    orders[i]['order_items'] = orderItems;
                }
                break;
            }
        }
        this.setState({orders: orders});
    }

    updateOrder(orderDetails, orderitem) {
        const orders = this.state.orders;

        for (let i=0;i<orders.length;i++){
            let orderItems = orders[i]['order_items'];
            let index = orderItems.findIndex(function (orderItem) {
                return orderItem.id === orderitem.id;
            });
            if (index > -1) {
                orders[i]['order_items'][index] = orderitem;
                orders[i]['order_details'] = orderDetails;
                break;
            }
        }
        this.setState({orders: orders});
    }

    changeStatus(order) {
        if (this.isOrderInQueue(order)) {
            NotificationManager.warning(locale.get('this_order_in_queue'), locale.get('order_number') + order.id);
            return;
        }
        this.addOrderToQueue(order);
        axios.post(Config.api() + 'orders/next-order-status/' + this.props.auth.business.id + '/' + order.id + '?status=' + this.state.status, {}, {
            withCredentials: Config.withCredentials()
        })
            .then((response) => {
                this.removeOrderFromQueue(order);
                let notifyType = 'success';
                if (response.status === 200 && response.data.status === true) {
                    this.updateOrder(response.data.order_details,response.data.order);
                    this.removeOrder(response.data.order);
                } else {
                    notifyType = 'error';
                }
                NotificationManager.success({
                    message: response.data.message,
                    title: locale.get('order_number') + order.id,
                    type: notifyType
                });
            }).catch((error) => {
            console.log('error',error)
            if (error.response && error.response.status === 401) {
                this.props.requiresReLogin();
            } else {

                this.removeOrderFromQueue(order);
                if(error.response && error.response.data && error.response.data.message){
                    NotificationManager.error(error.response.data.message + ' ' + locale.get('order_number') + order.id);
                }else{
                    NotificationManager.error(locale.get('an_error_occurred_while_changing_order_status') + locale.get('order_number') + order.id);
                }

            }
        });
    }
}

// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        auth: state.auth
    }
};


// Maps actions to props
const mapDispatchToProps = (dispatch) => ({
    requiresReLogin: () => dispatch(authActions.requiresRelogin(true, true))
});
export default connect(mapStateToProps, mapDispatchToProps)(Orders);

